import {ManagedTab} from "../../../managed-tabs";
import {TabBody} from "../../../tab-content";
import {OperationalTenancyColumn} from "./OperationalTenancyColumn";

export const OperationalTenancyTab: ManagedTab = () => {
  return (
    <TabBody name={"tenancy-tab"}>
      <OperationalTenancyColumn />
    </TabBody>
  );
};
